import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { LANGUAGES } from '../constant/languages';

// Contextを作成
export const LanguageContext = createContext<any>(null);

// LanguageProviderコンポーネント
export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // ローカルストレージから言語設定を取得（デフォルトは日本語）
  const storedLanguage = localStorage.getItem('appLanguage') || LANGUAGES.JA;
  const [language, setLanguage] = useState(storedLanguage);

  // 言語が変更されたらローカルストレージに保存
  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
